import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import type { Icon } from '@onefootprint/icons';
import { IcoDotSmall16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { JSX } from 'react';
type EventBodyEntryProps = {
  content: string | JSX.Element;
  testID?: string;
  iconComponent?: Icon | null;
  iconColor?: Color;
  lineHeight?: 'default' | 'large';
};
const EventBodyEntry = t0 => {
  const $ = _c(13);
  const {
    content,
    testID,
    iconComponent: t1,
    iconColor: t2,
    lineHeight: t3
  } = t0;
  const IconComponent = t1 === undefined ? IcoDotSmall16 : t1;
  const iconColor = t2 === undefined ? "tertiary" : t2;
  const lineHeight = t3 === undefined ? "large" : t3;
  let t4;
  if ($[0] !== IconComponent || $[1] !== iconColor || $[2] !== lineHeight) {
    t4 = IconComponent && <div className={cx("ml-2 flex justify-center items-center", lineHeight === "large" ? "min-h-[26px]" : "min-h-[20px]")}><IconComponent color={iconColor} /></div>;
    $[0] = IconComponent;
    $[1] = iconColor;
    $[2] = lineHeight;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = lineHeight === "large" ? "min-h-[26px]" : "min-h-[20px]";
  let t6;
  if ($[4] !== t5) {
    t6 = cx("flex flex-row flex-wrap items-center justify-start min-w-0 ml-2 text-body-2 text-tertiary md:flex-nowrap md:min-w-auto [&>*]:flex [&>*]:flex-row [&>*]:flex-wrap [&>*]:items-center [&>*]:justify-start", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== content || $[7] !== t6 || $[8] !== testID) {
    t7 = <div data-testid={testID} className={t6}>{content}</div>;
    $[6] = content;
    $[7] = t6;
    $[8] = testID;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = <div className="flex items-start justify-start">{t4}{t7}</div>;
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default EventBodyEntry;